import type { ComponentProps } from "react";

type MemberLockIconProps = {
  locked?: boolean;
} & ComponentProps<"svg">;

/** Locked padlock (closed shackle) */
const LockedIcon = (props: ComponentProps<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C8.8 4 8 6.66667 8 8V12M16 12H8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Unlocked padlock (open shackle) */
const UnlockedIcon = (props: ComponentProps<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12H6.6C6.26863 12 6 12.2686 6 12.6V19.4C6 19.7314 6.26863 20 6.6 20H17.4C17.7314 20 18 19.7314 18 19.4V12.6C18 12.2686 17.7314 12 17.4 12H16H8ZM8 12V8C8 6.66667 8.8 4 12 4C15.2 4 16 6.66667 16 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Yellow badge with locked/unlocked padlock icon */
const MemberLockIcon = ({ locked = true, className, ...props }: MemberLockIconProps) => (
  <span className="size-8 rounded-full bg-sun-100 flex items-center justify-center shrink-0">
    {locked ? (
      <LockedIcon className={className || "size-5 text-black"} {...props} />
    ) : (
      <UnlockedIcon className={className || "size-5 text-black"} {...props} />
    )}
  </span>
);

export { MemberLockIcon, LockedIcon, UnlockedIcon };
